//region 1. Platform Libraries
import express from 'express';
import MongoClient from 'mongodb';
//endregion

//region 2. Project Libraries
import checkObjectID from '../middleware/checkObjectID';
import checkStreamIndex from '../middleware/checkStreamIndex';
import DataAPI from '../DataAPI';
//endregion

const context = {
    router: express.Router({ mergeParams: true }),
    cameras: null,
    streamers: null,
    logger: null,
};

context.router.get('/', checkObjectID);
context.router.get('/', checkStreamIndex);
context.router.get('/', (req, res) => {
    const log = (lvl, msg) => context.logger.log(lvl, msg, { tags: `GET ${req.originalUrl}` });
    log('debug', JSON.stringify(req.params, null, 2));
    const _id = new MongoClient.ObjectID(req.params.id);
    context.cameras.findOne({ _id }, (findOneCameraErr, camera) => {
        if (findOneCameraErr) {
            log('error', findOneCameraErr.message);
            res.status(500).send(findOneCameraErr.message);
            return;
        }
        if (!camera) {
            const message = 'Camera Not Found';
            log('error', message);
            res.status(500).send(message);
            return;
        }
        /** @type Stream */
        const stream = camera.streams[req.params.index];
        if (!stream) {
            const message = 'Stream Not Found';
            log('error', message);
            res.status(500).send(message);
            return;
        }
        const rtspUrl = stream.rtsp_url;
        if (!rtspUrl) {
            const message = 'RTSP URL Not Found';
            log('error', message);
            res.status(500).send(message);
            return;
        }
        const reply = {
            rtspUrl,
            audio: false,
        };
        const expired = new Date(Date.now() - ((DataAPI.heartbeatInterval + 3) * 1000));
        context.streamers.find({
            updated: { $gt: expired },
        }).toArray((findStreamerErr, activeStreamers) => {
            if (findStreamerErr) {
                log('error', findStreamerErr.message);
                res.status(500).send(findStreamerErr.message);
                return;
            }
            if (!activeStreamers) {
                const message = 'No Streamer Available';
                log('error', message);
                res.status(500).send(message);
                return;
            }
            const max = activeStreamers.length;
            const selected = activeStreamers[Math.floor(Math.random() * max)];
            reply.streamerUrl = `http://${selected.private_ip}:${selected.port}`;
            log('info', '200 OK');
            log('debug', JSON.stringify(reply, null, 2));
            res.status(200).send(reply);
        });
    });
});

//noinspection JSUnusedGlobalSymbols
/**
 * Mount router for /c/:/s/:/live-info
 * @param {object}         options          Options
 * @param {object}         options.app      Express App
 * @param {MongoClient.Db} options.database Associated Database
 * @param {winston.Logger} options.logger   Logger
 */
export default function mountLiveInfo(options) {
    context.logger = options.logger;
    const log = (lvl, msg) => context.logger.log(lvl, msg, { tags: 'mountLiveInfo' });
    log('debug', 'Mounting router for /c/:/s/:/live-info....');
    options.app.use('/cameras/:id/streams/:index/live-info', context.router);
    context.cameras = options.database.collection('cameras');
    context.streamers = options.database.collection('streamers');
    log('info', 'Router for /c/:/s/:/live-info Mounted');
}
